import QRCodeStyling from 'qr-code-styling'
import { useMemo } from 'react'

export const templates = [
  {
    name: "Facebook",
    dotColor: "#1877F2",
    cornerSquareColor: "#1877F2",
    cornerDotColor: "#1877F2",
    backgroundColor: "#ffffff",
    dotShape: "rounded" as const,
    cornerSquareShape: "extra-rounded" as const,
    cornerDotShape: "dot" as const,
    logo: "/static/facebook-logo.png"
  },
  {
    name: "Telegram",
    dotColor: "#229ED9",
    cornerSquareColor: "#229ED9",
    cornerDotColor: "#229ED9",
    backgroundColor: "#ffffff",
    dotShape: "dots" as const,
    cornerSquareShape: "extra-rounded" as const,
    cornerDotShape: "dot" as const,
    logo: "/static/telegram-logo.png"
  },
  {
    name: "Instagram Pink",
    dotColor: "#E1306C",
    cornerSquareColor: "#C13584",
    cornerDotColor: "#C13584",
    backgroundColor: "#ffffff",
    dotShape: "dots" as const,
    cornerSquareShape: "extra-rounded" as const,
    cornerDotShape: "dot" as const,
  },
  {
    name: "微信",
    dotColor: "#07C160",
    cornerSquareColor: "#07C160",
    cornerDotColor: "#07C160",
    backgroundColor: "#ffffff",
    dotShape: "rounded" as const,
    cornerSquareShape: "extra-rounded" as const,
    cornerDotShape: "dot" as const,
  },
  {
    name: "QQ",
    dotColor: "#12B7F5",
    cornerSquareColor: "#12B7F5",
    cornerDotColor: "#12B7F5",
    backgroundColor: "#ffffff",
    dotShape: "dots" as const,
    cornerSquareShape: "extra-rounded" as const,
    cornerDotShape: "dot" as const,
  },
  {
    name: "WhatsApp",
    dotColor: "#25D366",
    cornerSquareColor: "#128C7E",
    cornerDotColor: "#128C7E",
    backgroundColor: "#ffffff",
    dotShape: "rounded" as const,
    cornerSquareShape: "extra-rounded" as const,
    cornerDotShape: "dot" as const
  },
  {
    name: "Dark Mode",
    dotColor: "#ffffff",
    cornerSquareColor: "#ffffff",
    cornerDotColor: "#ffffff",
    backgroundColor: "#000000",
    dotShape: "dots" as const,
    cornerSquareShape: "extra-rounded" as const,
    cornerDotShape: "dot" as const
  },
  {
    name: "Purple Style",
    dotColor: "#9333ea",
    cornerSquareColor: "#7928ca",
    cornerDotColor: "#7928ca",
    backgroundColor: "#ffffff",
    dotShape: "rounded" as const,
    cornerSquareShape: "extra-rounded" as const,
    cornerDotShape: "dot" as const
  },
  {
    name: "经典黑金",
    dotColor: "#FFD700",
    cornerSquareColor: "#000000",
    cornerDotColor: "#000000",
    backgroundColor: "#ffffff",
    dotShape: "dots" as const,
    cornerSquareShape: "square" as const,
    cornerDotShape: "dot" as const
  },
  {
    name: "海洋蓝",
    dotColor: "#1877F2",
    cornerSquareColor: "#1877F2",
    cornerDotColor: "#1877F2",
    backgroundColor: "#ffffff",
    dotShape: "rounded" as const,
    cornerSquareShape: "rounded" as const,
    cornerDotShape: "rounded" as const
  },
  {
    name: "森林绿",
    dotColor: "#228B22",
    cornerSquareColor: "#006400",
    cornerDotColor: "#006400",
    backgroundColor: "#ffffff",
    dotShape: "dots" as const,
    cornerSquareShape: "extra-rounded" as const,
    cornerDotShape: "dot" as const
  },
  {
    name: "樱花粉",
    dotColor: "#FFB7C5",
    cornerSquareColor: "#FF69B4",
    cornerDotColor: "#FF69B4",
    backgroundColor: "#ffffff",
    dotShape: "rounded" as const,
    cornerSquareShape: "extra-rounded" as const,
    cornerDotShape: "dot" as const
  },
  {
    name: "橙色活力",
    dotColor: "#FFA500",
    cornerSquareColor: "#FF8C00",
    cornerDotColor: "#FF8C00",
    backgroundColor: "#ffffff",
    dotShape: "dots" as const,
    cornerSquareShape: "extra-rounded" as const,
    cornerDotShape: "dot" as const
  },
  {
    name: "红宝石",
    dotColor: "#E0115F",
    cornerSquareColor: "#B22222",
    cornerDotColor: "#B22222",
    backgroundColor: "#ffffff",
    dotShape: "rounded" as const,
    cornerSquareShape: "extra-rounded" as const,
    cornerDotShape: "dot" as const
  },
  {
    name: "Default",
    dotColor: "#000000",
    cornerSquareColor: "#000000",
    cornerDotColor: "#000000",
    backgroundColor: "#ffffff",
    dotShape: "square" as const,
    cornerSquareShape: "square" as const,
    cornerDotShape: "square" as const
  }
]

const createTemplateQR = (template) => {
  return typeof window !== 'undefined' ? new QRCodeStyling({
    width: 128,
    height: 128,
    data: "https://douni.one",
    image: template.logo,
    dotsOptions: {
      type: template.dotShape,
      color: template.dotColor
    },
    backgroundOptions: {
      color: template.backgroundColor
    },
    cornersSquareOptions: {
      type: template.cornerSquareShape,
      color: template.cornerSquareColor
    },
    cornersDotOptions: {
      type: template.cornerDotShape,
      color: template.cornerDotColor
    },
    imageOptions: {
      crossOrigin: "anonymous",
      margin: 10,
      imageSize: 0.4,
    },
  }) : null;
};

export default function Component({ applyTemplate }: { applyTemplate: (template: typeof templates[0]) => void }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-5 lg:grid-cols-5 gap-6">
      {templates.map((template, index) => {

        const templateQR = useMemo(() => createTemplateQR(template), [template]);

        return (
          <button
            key={index}
            onClick={() => applyTemplate(template)}
            className="relative group flex flex-col items-center p-4"
          >
            <div className="w-32 h-32 bg-white rounded-lg shadow-sm overflow-hidden transition-transform group-hover:scale-105">
              <div
                ref={el => {
                  if (el) {
                    el.innerHTML = '';
                    templateQR.append(el);
                  }
                }}
                className="w-full h-full flex items-center justify-center"
              />
            </div>
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition-colors rounded-lg" />
          </button>
        );
      })}
    </div>
  )
}